import React, { useEffect } from 'react';
import { Modal as DsModal } from '@modernhealth/vital-components';

import { userService } from 'src/config/rootService';

import { CrisisModalContent } from './CrisisModalContent';

interface Props {
    visible: boolean;
    onClose: () => void;
    source?: string;
}

export const CrisisModal: React.FC<Props> = ({ onClose, visible, source }) => {
    useEffect(() => {
        if (visible && source) {
            userService.submitCrisisResourceEvent(source);
        }
    }, [visible, source]);

    return (
        <DsModal maxWidth={772} isVisible={visible} onCloseButtonClick={onClose}>
            {visible && <CrisisModalContent />}
        </DsModal>
    );
};
